import { render, staticRenderFns } from "./shopCell.vue?vue&type=template&id=3f63569a&scoped=true"
import script from "./shopCell.vue?vue&type=script&lang=js"
export * from "./shopCell.vue?vue&type=script&lang=js"
import style0 from "./shopCell.vue?vue&type=style&index=0&id=3f63569a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63569a",
  null
  
)

export default component.exports